import { render, staticRenderFns } from "./HotelCard.vue?vue&type=template&id=42b443d3&scoped=true"
import script from "./HotelCard.vue?vue&type=script&lang=js"
export * from "./HotelCard.vue?vue&type=script&lang=js"
import style0 from "./HotelCard.vue?vue&type=style&index=0&id=42b443d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b443d3",
  null
  
)

export default component.exports